"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const MultiSelect_vue_1 = __importDefault(require("./components/MultiSelect/MultiSelect.vue"));
exports.MultiSelect = MultiSelect_vue_1.default;
